// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__CY_sm","active":"NavigationItem_active__2qJ_P"};